'use client'

import { useCallback } from 'react'
import { useRouter } from 'next/navigation'
import { Anchor, Box, Button, Flex, Space, Text, Title } from '@mantine/core'
import {
  COURTYARD2_AUTH_SIGNUP_PATH,
  COURTYARD2_HOME_DASHBOARD_PATH,
  LOGIN_WITH_REDIRECT_TO_COURTYARD2,
  TERRACE_LOGIN_URL,
} from '@/constants'
import { KnockUser } from '@/lib/auth-utils'
import { onAuthLoginClick } from '@/lib/error-logger'
import { authChooseContent, CREATE_ACCOUNT, NEW_TO_KNOCK } from '@/text'
import styles from './ChoosePageContent.module.css'

const { TITLE, SUBTITLE } = authChooseContent

export default function ChoosePageContent({ user }: { user?: KnockUser }) {
  const router = useRouter()

  const onLogin = useCallback(
    (e: React.SyntheticEvent) => {
      if (user) {
        router.push(COURTYARD2_HOME_DASHBOARD_PATH)
      } else {
        onAuthLoginClick()
        router.push(LOGIN_WITH_REDIRECT_TO_COURTYARD2)
      }
    },
    [router, user]
  )

  return (
    <Box mx="auto">
      <Title order={1} c="brand-blue.9" ta="center" mb="md">
        {TITLE}
      </Title>
      <Title order={4} ta="center" mb="md">
        {SUBTITLE}
      </Title>
      <Space h="lg" />
      <Flex direction="column" gap="sm" w="260px" mx="auto" mb="xl">
        <Button
          className={styles.audienceButton}
          component="a"
          type="button"
          size="lg"
          variant="outline"
          color="black"
          onClick={onLogin}
        >
          <Text className={styles.audienceButtonText}>I&rsquo;m a homebuyer</Text>
        </Button>
        <Button
          className={styles.audienceButton}
          component="a"
          type="button"
          size="lg"
          variant="outline"
          color="black"
          href={TERRACE_LOGIN_URL}
        >
          <Text className={styles.audienceButtonText}>I&rsquo;m an agent</Text>
        </Button>
        <Button
          className={styles.audienceButton}
          component="a"
          type="button"
          size="lg"
          variant="outline"
          color="black"
          href={TERRACE_LOGIN_URL}
        >
          <Text className={styles.audienceButtonText}>I&rsquo;m a lender</Text>
        </Button>
      </Flex>

      <Text size="sm" ta="center" mb="md">
        {NEW_TO_KNOCK}
        <Anchor ml="xs" fw={700} href={COURTYARD2_AUTH_SIGNUP_PATH}>
          {CREATE_ACCOUNT}
        </Anchor>
      </Text>
    </Box>
  )
}
